
import logo from "./../../assets/img/Template-logo.png";
import mahtas from "./../../assets/img/mahtas-logo.png";
import React,{ useState, useEffect } from "react";
import { API_Link, validateHeader } from "../../commons/Constants";
import axios from "axios";
import { Link } from "react-router-dom";
import pdficon from "./../../assets/img/pdficon.png";
import gif from "../../assets/img/spin.gif";
import { setLoading } from "../../features/setting/apiSlice";
import store from "../../store";
import { useDispatch } from "react-redux";
import EvidenceTableSingle from "../evidenceTableSingle";
function TechScan() {
  const [data, setData] = useState([]);
  const [isLoadingData, setisLoadingData] = useState(false);
  const dispatch = useDispatch();
  const MD5hash = validateHeader();
  const [reviewData, setreviewData] = useState([]);
  // const [Authors, setAuthors] = useState([]);
  const [interventions, setInterventions] = useState([]);
  const [outcomes, setOutcomes] = useState([]);
  const [participants, setParticipants] = useState([]);
  const [punchline, setPunchline] = useState([]);
  const [picoSearchs, setPicoSearches] = useState([]);
  const [isloadingPicoSearchs, setisloadingPicoSearchs] = useState(false);

  const [abstract, setAbstract] = useState([]);
  const [prismaValue, setPrismaValue] = useState([]);
  const [isLoadingPrismaValue, setisLoadingPrismaValue] = useState([]);

  const [reasons, setReasons] = useState([]);
  const [n, setn] = useState([]);
  const [title, setTitle] = useState([]);
  // const [Author, setAuthor] = useState([]);
  const [year, setYear] = useState([]);
  const [pages, setPages] = useState([]);
  const [pmid, setPmid] = useState([]);
  const [judgement, setJudgment] = useState([]);
  const [rct, setRct] = useState([]);
  const [findings, setFindings] = useState([]);
  const [multidata, setMultidata] = useState([]);

  const [isLoadingMultiData, setisLoadingMultiData] = useState(false);
  const [studyId, setStudyId] = useState([]);
  const [maintitle, setMaintitle] = useState([]);
  const [title1, setTitle1] = useState([]);
  const [biasesData, setBiasesData] = useState([]);
  const [judgementData, setJudgmentData] = useState([]);
  const [isLoadingJudgementData, setisLoadingJudgementData] = useState(false);

  const [picoData, setPicoData] = useState([]);
  const [isLoadingPicoData, setisLoadingPicoData] = useState(false);

  const styles = {
    tdStyling: {
      backgroundColor: "#eaefef",
      padding: "5px",
      border: "1px solid #000",
      verticalAlign: "top",
    },
    thStyling: {
      border: "1px solid black",
      textAlign: "center",
      color: "#219ebc",
      backgroundColor: "#d9e2f3",
    },
    tableStyling: {
      borderCollapse: "collapse",
      width: "100%",
      padding: "10px",
      height: "auto",
      backgroundColor: "#00b0f0",
      color: "white",
    },
  };

  const getReviews = () => {
    const user = JSON.parse(localStorage.getItem("user"));
    const token = user?.token;
    const studyId = localStorage.getItem("studyId");
    var config = {
      method: "get",
      url: `${API_Link}getReviews`,
      headers: {
        "misr-auth": MD5hash,
        Authorization: `Bearer ${token}`,
      },
      params: {
        id: studyId,
      },
    };
    axios(config)
      .then(function (response) {
        const APIresponse = response.data.reviews;
        console.log("DATA is here :", APIresponse);
        setMaintitle(APIresponse);
        const title1 = APIresponse[0].title;
        console.log("TITLE:", title1);
        setTitle1(title1);
      })
      .catch(function (error) {
        console.log(error);
      });
  };
  const getReviewData = () => {
    setisLoadingMultiData(true);
    store.dispatch(
      setLoading({ apiName: "getReviewsData(TS)", isLoading: true })
    );

    const user = JSON.parse(localStorage.getItem("user"));
    const token = user?.token;
    const studyId = localStorage.getItem("studyId");

    var config = {
      method: "get",
      url: `${API_Link}getExtractedReportJson?review_id=${studyId}`,
      // url: `${API_Link}getExtractedReportJson`,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
        "misr-auth": MD5hash,
      },
    };
    axios(config)
      .then(function (response) {
        const Response1 = response.data.data[0].report_json;
        const Response2 = JSON.parse(Response1);
        const ResponseData = Response2.article_data[0];
        setreviewData(ResponseData);
        // const Authors = ResponseData.dubious.authors;
        // setAuthors(Authors)
        const interventions = ResponseData.ml.pico_span.interventions;
        setInterventions(interventions);
        const abstract = ResponseData.dubious.abstract;
        setAbstract(abstract);
        const outcomes = ResponseData.ml.pico_span.outcomes;
        setOutcomes(outcomes);
        const participants = ResponseData.ml.pico_span.population;
        setParticipants(participants);
        const punchline = ResponseData.ml.punchlines;
        setPunchline(punchline);
        const n = ResponseData.ml.sample_size;
        setn(n);
        const title = ResponseData.dubious.title;
        console.log("title: ", title);
        setTitle(title);
        // const Author = ResponseData.dubious.authors[0].forename;
        // setAuthor(Author)
        const year = ResponseData.dubious.year;
        setYear(year);
        const pages = ResponseData.dubious.pages;
        setPages(pages);
        const pmid = ResponseData.dubious.pmid;
        setPmid(pmid);
        const judgement = ResponseData.ml.bias;
        setJudgment(judgement);
        const rct = ResponseData.ml.rct;
        setRct(rct);
        const findings = ResponseData.ml.finding_direction;
        setFindings(findings);
        const multidata = Response2.article_data;
        console.log("MultiDATA: ", multidata);
        setMultidata(multidata);
        setisLoadingMultiData(false);
        store.dispatch(
          setLoading({ apiName: "getReviewsData(TS)", isLoading: false })
        );
      })
      .catch(function (error) {
        console.log(error);
        setisLoadingMultiData(false);
        store.dispatch(
          setLoading({ apiName: "getReviewsData(TS)", isLoading: false })
        );
      })
      .finally(function () {
        setisLoadingMultiData(false);
        store.dispatch(
          setLoading({ apiName: "getReviewsData(TS)", isLoading: false })
        );
      });
  };
  const getReviewEvidence = () => {
    setisLoadingData(true);
    store.dispatch(
      setLoading({ apiName: "getReviewEvidence(TS)", isLoading: true })
    );

    const user = JSON.parse(localStorage.getItem("user"));
    const token = user?.token;
    const studyId = localStorage.getItem("studyId");

    var config = {
      method: "get",
      url: `${API_Link}getReviewEvidence?review_id=${studyId}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
        "misr-auth": MD5hash,
      },
    };
    axios(config)
      .then(function (response) {
        const APIresponse = response.data.evidences;
        console.log("DATA is here :", APIresponse);
        setData(APIresponse);
        setisLoadingData(false);
        store.dispatch(
          setLoading({ apiName: "getReviewEvidence(TS)", isLoading: false })
        );
      })
      .catch(function (error) {
        console.log(error);
        setisLoadingData(false);
        store.dispatch(
          setLoading({ apiName: "getReviewEvidence(TS)", isLoading: false })
        );
      })
      .finally(function () {
        setisLoadingData(false);
        store.dispatch(
          setLoading({ apiName: "getReviewEvidence(TS)", isLoading: false })
        );
      });
  };

  const getPicoSearches = () => {
    setisloadingPicoSearchs(true);
    store.dispatch(
      setLoading({ apiName: "getPicoSearches(TS)", isLoading: true })
    );

    let review_id = localStorage.getItem("studyId");

    const user = JSON.parse(localStorage.getItem("user"));
    const token = user?.token;

    var config = {
      method: "get",
      url: `${API_Link}getPicoSearches?review_id=${review_id}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
        "misr-auth": MD5hash,
      },
    };
    axios(config)
      .then(function (response) {
        setPicoSearches(
          response.data.picoSearches.filter(
            (item) => item.database !== "RISimport"
          )
        );
        setisloadingPicoSearchs(false);
        store.dispatch(
          setLoading({ apiName: "getPicoSearches(TS)", isLoading: false })
        );
      })
      .catch(function (error) {
        console.log(error);
        setisloadingPicoSearchs(false);
        store.dispatch(
          setLoading({ apiName: "getPicoSearches(TS)", isLoading: false })
        );
      })
      .finally(function () {
        setisloadingPicoSearchs(false);
        store.dispatch(
          setLoading({ apiName: "getPicoSearches(TS)", isLoading: false })
        );
      });
  };

  const PrismaComponent = () => {
    setisLoadingPrismaValue(true);
    store.dispatch(setLoading({ apiName: "Prisma(TS)", isLoading: true }));

    const user = JSON.parse(localStorage.getItem("user"));
    const studyId = localStorage.getItem("studyId");
    const token = user?.token;

    var config = {
      method: "get",
      url: `${API_Link}getPrismaCounts?review_id=${studyId}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
        "misr-auth": MD5hash,
      },
    };

    axios(config)
      .then(function (response) {
        const resData = response;
        // document.querySelector(".preload").style.display = "none"//stop the load
        setPrismaValue(resData.data.counts);
        setisLoadingPrismaValue(false);
        console.log("getPrisma", prismaValue);
        console.warn("reasons", resData.data.counts[0].excluded);
        setReasons(resData.data.counts[0].excluded);
        store.dispatch(setLoading({ apiName: "Prisma(TS)", isLoading: false }));
      })
      .catch(function (error) {
        console.log(error);
        setisLoadingPrismaValue(false);
        store.dispatch(setLoading({ apiName: "Prisma(TS)", isLoading: false }));
      });
  };

  //
  const getReviewBiases = () => {
    const user = JSON.parse(localStorage.getItem("user"));
    const studyId = localStorage.getItem("studyId");
    const token = user?.token;

    var config = {
      method: "get",
      url: `${API_Link}getReviewBiases?review_id=${studyId}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
        "misr-auth": MD5hash,
      },
    };

    axios(config)
      .then(function (response) {
        const resData = response;
        setBiasesData(resData.data.biases);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const getReviewJudgements = () => {
    setisLoadingJudgementData(true);
    store.dispatch(
      setLoading({ apiName: "getReviewJudgements(TS)", isLoading: true })
    );

    const user = JSON.parse(localStorage.getItem("user"));
    const studyId = localStorage.getItem("studyId");
    const token = user?.token;

    var config = {
      method: "get",
      url: `${API_Link}getReviewJudgements?review_id=${studyId}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
        "misr-auth": MD5hash,
      },
    };

    axios(config)
      .then(function (response) {
        const resData = response;
        setJudgmentData(resData.data);
        setisLoadingJudgementData(false);
        store.dispatch(
          setLoading({ apiName: "getReviewJudgements(TS)", isLoading: false })
        );
      })
      .catch(function (error) {
        console.log(error);
        setisLoadingJudgementData(false);
        store.dispatch(
          setLoading({ apiName: "getReviewJudgements(TS)", isLoading: false })
        );
      })
      .finally(function () {
        setisLoadingJudgementData(false);
        store.dispatch(
          setLoading({ apiName: "getReviewJudgements(TS)", isLoading: false })
        );
      });
  };
  const getReviewPico = () => {
    setisLoadingPicoData(true);

    const user = JSON.parse(localStorage.getItem("user"));
    const studyId = localStorage.getItem("studyId");
    const token = user?.token;

    var config = {
      method: "get",
      url: `${API_Link}getReviewPicoSentences?review_id=${studyId}`,
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token,
        "misr-auth": MD5hash,
      },
    };
    localStorage.setItem("pdfAId", "");
    axios(config)
      .then(function (response) {
        const resData = response;
        setPicoData(resData.data);
        setisLoadingPicoData(false);
      })
      .catch(function (error) {
        console.log(error);
        setisLoadingPicoData(false);
      });
  };

  //
  const headings1 = [
    { id: 1, headingText: "Random sequence generation" },
    { id: 2, headingText: "Allocation concealment" },
    { id: 3, headingText: "Blinding of participants and personnel" },
    { id: 4, headingText: "Blinding of outcome assessment" },
    { id: 5, headingText: "Incomplete outcome data" },
    { id: 6, headingText: "Selective reporting" },
  ];
  const headings2 = [
    { id: 1, headingText: "Participants" },
    { id: 2, headingText: "Intervention" },
    { id: 3, headingText: "OutComes" },
  ];
  const output = [];

  const tableRows = [];
  if (judgementData.judgements) {
    var topLevelKeys = Object.keys(judgementData.judgements);
    console.log("output", topLevelKeys);
  }
  if (picoData.picos) {
    var picoIds = Object.keys(picoData.picos);
    console.log("pico ids", picoIds);
  }
  useEffect(() => {
    getReviewEvidence();
    getReviewData();
    getPicoSearches();
    PrismaComponent();
    getReviews();
    getReviews();
    getReviewBiases();
    getReviewJudgements();
    getReviewPico();
  }, []);

  const judgements = judgementData.judgements;
  const picos = picoData.picos;
  return (
    <div
      style={{
        paddingLeft: "20px",
        paddingRight: "20px",
        marginBottom: "50px",
      }}
    >
      <div style={{ display: "flex" }}>
        <span>
          <p
            style={{
              textAlign: "left",
              height: "100px",
              width: "150px",
              marginRight: "100px",
            }}
          >
            <img src={logo} style={{ height: "50px" }} />{" "}
          </p>
        </span>
        <span>
          <p style={{ textAlign: "left", height: "100px", width: "350px" }}>
            <img src={mahtas} style={{ height: "50px" }} />{" "}
          </p>
        </span>
      </div>
      <table style={{ width: "100%", fontWeight: "bold" }}>
        <tr>
          <td
            style={{
              width: "70%",
              backgroundColor: "white",
              textAlign: "left",
              fontSize: "20px",
              border: "1px solid black",
              padding: "5px",
            }}
          >
            <span style={{ color: "green" }}>TechScan</span> Horizon Scanning
          </td>
          <td
            style={{
              border: "1px solid black",
              fontSize: "20px",
              padding: "5px",
            }}
          >
            Report No.: 000/year
          </td>
        </tr>
      </table>
      <br />
      <div style={{ textAlign: "center", padding: "5px" }}>
        <p style={{ fontWeight: "bold", fontSize: "26px" }}>
          {" "}
          <span style={{ color: "green", marginRight: "10px" }}>
            {" "}
            TITLE:{" "}
          </span>{" "}
          {title1}
        </p>
      </div>
      <p style={{ fontStyle: "italic", textAlign: "left" }}> Keywords: </p>
      <div
        style={{
          padding: "1px",
          textAlign: "left",
          backgroundColor: "#365F91",
          color: "white",
          fontWeight: "bold",
        }}
      >
        <strong>SUMMARY OF TECHNOLOGY </strong>
      </div>
      <p style={{ textAlign: "left" }}> Briefly on:</p>
      <div style={{ textAlign: "left", paddingLeft: "10px " }}>
        <ul>
          <li>• The technology (what is it, how it works)</li>
          <li>• Related (patient group), disease burden</li>
          <li>• The developer</li>
          <li>• Current stage of development</li>
          <li>• Photo of the technology (if available)</li>
        </ul>
      </div>
      <div
        style={{
          padding: "1px",
          textAlign: "left",
          backgroundColor: "#365F91",
          color: "white",
          fontWeight: "bold",
        }}
      >
        <strong>Abstract </strong>
      </div>{" "}
      <br />
      <p
        style={{
          textAlign: "justify",
          fontFamily: "sans-serif",
          fontSize: "16px",
        }}
      >
        {abstract}
      </p>
      <br />
      <br />
      <div
        style={{
          padding: "1px",
          textAlign: "left",
          backgroundColor: "#365F91",
          color: "white",
          fontWeight: "bold",
        }}
      >
        <strong>INNOVATIVENESS</strong>
      </div>
      <br />
      <table style={{ width: "100%" }}>
        <tr>
          <td
            style={{
              width: "70%",
              backgroundColor: "#A5D5E2",
              textAlign: "center",
              fontSize: "19px",
            }}
          >
            Novel, completely new
          </td>
          <td
            style={{
              fontSize: "20px",
              backgroundColor: "#4BACC6",
              color: "white",
              textAlign: "center",
            }}
          >
            ✓
          </td>
        </tr>
        <tr>
          <td
            style={{
              width: "70%",
              backgroundColor: "#D2EAF1",
              textAlign: "center",
              fontSize: "19px",
            }}
          >
            Incremental improvement of the existing technology
          </td>
          <td
            style={{
              fontSize: "20px",
              backgroundColor: "#4BACC6",
              color: "white",
            }}
          ></td>
        </tr>
        <tr>
          <td
            style={{
              width: "70%",
              backgroundColor: "#A5D5E2",
              textAlign: "center",
              fontSize: "19px",
            }}
          >
            New indication of an existing technology
          </td>
          <td
            style={{
              fontSize: "20px",
              backgroundColor: "#4BACC6",
              color: "white",
            }}
          ></td>
        </tr>
      </table>
      <br />
      {/* <div
        style={{
          padding: "1px",
          textAlign: "left",
          backgroundColor: "#365F91",
          color: "white",
          fontWeight: "bold",
        }}
      >
        <strong>DISEASE BURDEN </strong>
      </div>
      <br /> */}
      <div
        style={{
          padding: "1px",
          textAlign: "left",
          backgroundColor: "#365F91",
          color: "white",
          fontWeight: "bold",
        }}
      >
        <strong>CHARACTERISTICS OF STUDIES</strong>
      </div>
      <br />
      {isLoadingMultiData ? (
        <div className="preload">
          <img src={gif} alt="Loading..." />
        </div>
      ) : (
        <>
          {biasesData?.map((biasesItem) => {
            const articleId = biasesItem.article_id.toString();

            // Find corresponding data for the same articleId in topLevelKeys and picoIds
            const topLevelKeyData = topLevelKeys?.includes(articleId)
              ? articleId
              : null;
            const picoData = picoIds?.includes(articleId) ? articleId : null;

            return (
              <div key={articleId}>
                {/* Biases Data */}
                <>
                  <p>
                    <strong>{biasesItem.author_year}</strong>
                  </p>
                  <table style={{ border: "1px solid black", padding: "2px" }}>
                    <tr style={{ border: "1px solid black", padding: "2px" }}>
                      <td
                        style={{
                          color: "#219ebc",
                          backgroundColor: "#d9e2f3",
                          padding: "5px",
                        }}
                      >
                        Participants
                      </td>
                      <td
                        style={{
                          border: "1px solid black",
                          textAlign: "justify",
                          padding: "5px",
                        }}
                      >
                        {biasesItem.population}
                      </td>
                    </tr>
                    <tr style={{ border: "1px solid black", padding: "2px" }}>
                      <td
                        style={{
                          color: "#219ebc",
                          backgroundColor: "#d9e2f3",
                          padding: "5px",
                        }}
                      >
                        Interventions
                      </td>
                      <td
                        style={{
                          border: "1px solid black",
                          textAlign: "justify",
                          padding: "5px",
                        }}
                      >
                        {biasesItem.interventions}
                      </td>
                    </tr>
                    <tr style={{ border: "1px solid black", padding: "2px" }}>
                      <td
                        style={{
                          color: "#219ebc",
                          backgroundColor: "#d9e2f3",
                          padding: "5px",
                        }}
                      >
                        Outcomes
                      </td>
                      <td
                        style={{
                          border: "1px solid black",
                          textAlign: "justify",
                          padding: "5px",
                        }}
                      >
                        {biasesItem.outcomes}
                      </td>
                    </tr>
                  </table>
                </>

                {/* Top Level Keys */}
                {topLevelKeyData && (
                  <table className="table table-bordered table-striped mt-4 judgement-table">
                    <thead>
                      <tr>
                        <th style={styles.thStyling}>Bias</th>
                        <th style={styles.thStyling}>Judgment</th>
                        <th style={styles.thStyling}>Support for judgment</th>
                      </tr>
                    </thead>
                    <tbody>
                      {headings1?.map((item, index) => {
                        // Match heading ID to bias field in biasesItem
                        const biasField = {
                          1: biasesItem?.random_sequence_generation,
                          2: biasesItem?.allocation_concealment,
                          3: biasesItem?.participants_personnel_blinding,
                          4: biasesItem?.outcome_assessment_blinding,
                          5: biasesItem?.incomplete_outcome_data,
                          6: biasesItem?.selective_reporting,
                        }[item.id];

                        return (
                          <tr key={index}>
                            <td>{item.headingText}</td>
                            <td>{biasField}</td>
                            <td>
                              {judgements[articleId]?.[item?.id]?.map(
                                (judgement, idx) => (
                                  <div key={idx}>
                                    <span>{judgement.support_text}</span>
                                    <Link
                                      className="Editpdf-icon"
                                      to={`/biasbot/${articleId}`}
                                    >
                                      <img src={pdficon} alt="" height="17px" />
                                      <span className="tooltiptextannotation">
                                        Jump to Annotation
                                      </span>
                                    </Link>
                                  </div>
                                )
                              )}
                            </td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                )}

                {/* PICO Data */}
                {picoData && (
                  <table className="table table-bordered table-striped mt-4 judgement-table">
                    <thead>
                      <tr>
                        <th style={styles.thStyling}>PICO</th>
                        <th style={styles.thStyling}>Support for Pico</th>
                      </tr>
                    </thead>
                    <tbody>
                      {headings2?.map((item, index) => (
                        <tr key={index}>
                          <td>{item?.headingText}</td>
                          <td>
                            {picos[articleId]?.[index + 1]?.map((pico, idx) => (
                              <div key={idx}>
                                <span>{pico.pico_text}</span>
                                <Link
                                  to={`/picobot/${articleId}`}
                                  className="Editpdf-icon"
                                >
                                  <img src={pdficon} alt="" height="17px" />
                                  <span className="tooltiptextannotation">
                                    Jump to Annotation
                                  </span>
                                </Link>
                              </div>
                            ))}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                )}
              </div>
            );
          })}
        </>
      )}
      <br />
      {/* <div
        style={{
          padding: "1px",
          textAlign: "left",
          backgroundColor: "#365F91",
          color: "white",
          fontWeight: "bold",
        }}
      >
        <strong>CURRENT OPTIONS FOR PATIENTS</strong>
      </div>
      <br /> */}
      <div
        style={{
          padding: "1px",
          textAlign: "left",
          backgroundColor: "#365F91",
          color: "white",
          fontWeight: "bold",
        }}
      >
        <strong>POTENTIAL IMPACT OF TECHNOLOGY </strong>
      </div>
      <br />
      <table style={{ width: "100%" }}>
        <tr>
          <td style={{ width: "10%" }}>a.</td>
          <td style={{ textAlign: "left" }}>
            Clinical Impact - mortality, morbidity, quality of life, diagnosis
          </td>
        </tr>
        <tr>
          <td style={{ width: "10%" }}>b.</td>
          <td style={{ textAlign: "left" }}>cost</td>
        </tr>
        <tr>
          <td style={{ width: "10%" }}>c.</td>
          <td style={{ textAlign: "left" }}>
            Organizational Issue- services, infrastructure, human resources{" "}
          </td>
        </tr>
        <tr>
          <td style={{ width: "10%" }}>d.</td>
          <td style={{ textAlign: "left" }}>safety</td>
        </tr>
      </table>
      <br />
      <div
        style={{
          padding: "1px",
          textAlign: "left",
          backgroundColor: "#365F91",
          color: "white",
          fontWeight: "bold",
        }}
      >
        <strong>Trail Summaries</strong>
      </div>
      <br />
      <table
        className="table table-striped blue-bg-th-table"
        style={{
          borderCollapse: "collapse",
          width: "100%",
          border: "1px solid black",
          marginTop: "15px",
        }}
      >
        <tr style={{ border: "1px solid black" }}>
          <th
            style={{
              border: "1px solid black",
              textAlign: "center",
              color: "#219ebc",
              backgroundColor: "#d9e2f3",
            }}
          >
            {" "}
            Title & Authors{" "}
          </th>
          <th
            style={{
              border: "1px solid black",
              textAlign: "center",
              color: "#219ebc",
              backgroundColor: "#d9e2f3",
            }}
          >
            {" "}
            Participants{" "}
          </th>

          <th
            style={{
              border: "1px solid black",
              textAlign: "center",
              color: "#219ebc",
              backgroundColor: "#d9e2f3",
            }}
          >
            {" "}
            Interventions{" "}
          </th>

          <th
            style={{
              border: "1px solid black",
              textAlign: "center",
              color: "#219ebc",
              backgroundColor: "#d9e2f3",
            }}
          >
            {" "}
            Outcomes{" "}
          </th>

          <th
            style={{
              border: "1px solid black",
              textAlign: "center",
              color: "#219ebc",
              backgroundColor: "#d9e2f3",
            }}
          >
            {" "}
            punchline{" "}
          </th>

          <th
            style={{
              border: "1px solid black",
              textAlign: "center",
              color: "#219ebc",
              backgroundColor: "#d9e2f3",
            }}
          >
            {" "}
            finding{" "}
          </th>
        </tr>
        {isLoadingMultiData ? (
          <div className="preload">
            <img src={gif} alt="Loading..." />
          </div>
        ) : (
          <>
            {interventions.length === 0 ||
            participants.length === 0 ||
            outcomes.length === 0 ||
            punchline.length === 0 ? (
              multidata?.map((item) => {
                console.log("item: ", item);
                return (
                  <tr>
                    <td style={styles.tdStyling}>
                      {item.grobid.title && (
                        <p>
                          <strong>Title: </strong> {item.grobid.title}
                        </p>
                      )}
                      {item.grobid.authors && (
                        <p>
                          <strong>Authors: </strong>{" "}
                          {item?.grobid?.authors
                            ?.map(
                              (author) =>
                                `${author.forename
                                  .split(" ")
                                  ?.map(
                                    (word) =>
                                      word.charAt(0).toUpperCase() +
                                      word.slice(1)
                                  )
                                  .join(" ")} ${author.lastname
                                  .split(" ")
                                  .map(
                                    (word) =>
                                      word.charAt(0).toUpperCase() +
                                      word.slice(1)
                                  )
                                  .join(" ")}`
                            )
                            .join(", ")}
                        </p>
                      )}
                      {item.grobid.journal && (
                        <p>
                          <strong>Journal: </strong> {item.grobid.journal}
                        </p>
                      )}
                    </td>
                    <td style={styles.tdStyling}>
                      {item?.ml?.pico_span?.population?.map((inter) => (
                        <div>
                          <span>{inter}</span>
                        </div>
                      ))}
                    </td>
                    <td style={styles.tdStyling}>
                      {item?.ml?.pico_span?.interventions?.map((inter) => (
                        <div>
                          <span>{inter}</span>
                        </div>
                      ))}
                    </td>
                    <td style={styles.tdStyling}>
                      {item?.ml?.pico_span?.outcomes?.map((inter) => (
                        <div>
                          <span>{inter}</span>
                        </div>
                      ))}
                    </td>
                    <td style={styles.tdStyling}>{item?.ml?.punchlines}</td>
                    <td style={styles.tdStyling}>
                      {item?.ml?.finding_direction}
                    </td>
                  </tr>
                );
              })
            ) : (
              <td colspan="9" className="text-center bg-danger text-light">
                {" "}
                <strong>You don't have any Trail Summaries</strong>{" "}
              </td>
            )}
          </>
        )}
      </table>
      {/* Pico Bot */}
      <div
        style={{
          padding: "1px",
          textAlign: "left",
          backgroundColor: "#365F91",
          color: "white",
          fontWeight: "bold",
        }}
      >
        <strong>Risk of bias table</strong>
      </div>
      <br />
      <table
        style={{
          marginLeft: "auto",
          marginRight: "auto",
          borderCollapse: "collapse",
          padding: 0,
          marginTop: "10px",
        }}
      >
        <tr className="bias-header-row">
          <th
            style={{
              verticalAlign: "bottom",
              textAlign: "left",
              margin: "20px",
              padding: "8px",
              borderBottom: "1px solid #ddd",
            }}
          >
            trial
          </th>
          <th
            style={{
              verticalAlign: "bottom",
              textAlign: "left",
              padding: "8px",
              borderBottom: "1px solid #ddd",
            }}
          >
            design
          </th>
          {judgement?.map((item, index) => (
            <th
              key={index}
              style={{
                height: "70px",
                whiteSpace: "normal",
                padding: "8px",
                borderBottom: "1px solid #ddd",
              }}
            >
              <div
                style={{
                  width: "100px",
                  fontSize: "14px",
                  padding: "10px",
                }}
              >
                <span>{item?.domain}</span>
              </div>
            </th>
          ))}
        </tr>
        {multidata?.map((item, index) => (
          <tr key={index}>
            <td
              style={{
                fontSize: "12px",
                padding: "10px",
                borderBottom: "1px solid #ddd",
              }}
            >
              {item.pubmed.length === 0
                ? ""
                : item?.pubmed?.authors
                    ?.map(
                      (author) =>
                        `${author.forename
                          .split(" ")
                          ?.map(
                            (word) =>
                              word.charAt(0).toUpperCase() + word.slice(1)
                          )
                          .join(" ")} ${author.lastname
                          .split(" ")
                          ?.map(
                            (word) =>
                              word.charAt(0).toUpperCase() + word.slice(1)
                          )
                          .join(" ")}`
                    )
                    .join(", ")}{" "}
              {item.pubmed.year}
              {item.grobid.length === 0
                ? ""
                : item?.grobid?.authors
                    ?.map(
                      (author) =>
                        `${author?.forename
                          .split(" ")
                          ?.map(
                            (word) =>
                              word.charAt(0).toUpperCase() + word.slice(1)
                          )
                          .join(" ")} ${author.lastname
                          ?.split(" ")
                          ?.map(
                            (word) =>
                              word.charAt(0).toUpperCase() + word.slice(1)
                          )
                          .join(" ")}`
                    )
                    .join(", ")}{" "}
              {item.grobid.year}
            </td>
            <td style={{ padding: "10px", borderBottom: "1px solid #ddd" }}>
              {item.ml.rct.is_rct === false ? <p>Not Rct</p> : <p>Rct</p>}
            </td>
            {item?.ml?.bias?.map((bi, biasIndex) => (
              <td
                key={biasIndex}
                style={{
                  backgroundColor:
                    bi.judgement === "high/unclear" ? "red" : "green",
                  color: "white",
                  textAlign: "center",
                  width: "40px",
                  padding: "10px",
                  borderBottom: "1px solid #ddd",
                }}
              >
                {bi.judgement === "high/unclear" ? "?" : "+"}
              </td>
            ))}
          </tr>
        ))}
      </table>
      <br />
      {/* <div
        style={{
          padding: "1px",
          textAlign: "left",
          backgroundColor: "#365F91",
          color: "white",
          fontWeight: "bold",
        }}
      >
        <strong>CONCLUSION</strong>
      </div>
      <br /> */}
      <div
        style={{
          padding: "1px",
          textAlign: "left",
          backgroundColor: "#365F91",
          color: "white",
          fontWeight: "bold",
        }}
      >
        <strong>EVIDENCE </strong>
      </div>
      <p style={{ textAlign: "left" }}>
        List of studies conducted on the technology (published papers /
        abstracts / unpublished paper / ongoing studies / conference paper
        presentation) - Based on available evidence up to (date)
      </p>
      <EvidenceTableSingle />
      <br />
      <div
        style={{
          padding: "1px",
          textAlign: "left",
          backgroundColor: "#365F91",
          color: "white",
          fontWeight: "bold",
        }}
      >
        <strong>REFERENCES </strong>
      </div>{" "}
      <br />
      {isLoadingMultiData ? (
        <div className="preload">
          <img src={gif} alt="Loading..." />
        </div>
      ) : (
        <div>
          {multidata?.map((item, index) => {
            return (
              <>
                {item.dubious.length === 0 ? (
                  <p style={{ justifyContent: "space-between" }}>
                    {index + 1}. <span style={{ marginLeft: "5px" }}></span>
                    {item.pubmed.length === 0
                      ? ""
                      : item.pubmed.authors[0].forename}{" "}
                    ,
                    {item.pubmed.length === 0
                      ? ""
                      : item.pubmed.authors[0].lastname}
                    ,{item.pubmed.title} , {item.pubmed.pages}, PMID:{" "}
                    {item.pubmed.pmid}
                  </p>
                ) : (
                  <p style={{ justifyContent: "space-between" }}>
                    {index + 1}. <span style={{ marginLeft: "5px" }}></span>
                    {item.dubious.length === 0
                      ? ""
                      : item.dubious.authors[0].forename}{" "}
                    ,
                    {item.dubious.length === 0
                      ? ""
                      : item.dubious.authors[0].lastname}
                    ,{item.dubious.title} , {item.dubious.pages}, PMID:{" "}
                    {item.dubious.pmid}
                  </p>
                )}
              </>
            );
          })}
        </div>
      )}
      <br />
      <p style={{ textAlign: "left" }}>
        <strong>Prepared by:</strong>
      </p>
      <br />
      <p style={{ textAlign: "left" }}>
        <strong>Reviewed by:</strong>
      </p>
      <br />
      <div
        style={{
          border: "1px solid black",
          textAlign: "left",
          paddingLeft: "10px ",
        }}
      >
        <p>
          <strong>Disclosure: </strong> The author of this report has no
          competing interest in this subject and the preparation of this report
          is totally funded by the Ministry of Health, Malaysia.
        </p>
        <p>
          {" "}
          <strong>Disclaimer:</strong> TechScan report is prepared based on
          information available at the time of research and a limited
          literature. It is not a definitive statement on the safety,
          effectiveness or cost effectiveness of the health technology covered.
          Additionally, other relevant scientific findings may have been
          reported since completion of this report.
        </p>
        <p></p>
        <div style={{ textAlign: "left", paddingLeft: "10px " }}>
          Horizon Scanning Unit, MaHTAS, <br />
          Medical Development Division, <br />
          Ministry of Health, Malaysia
          <br />
          Email: horizonscanningunit.cptk@moh.gov.my
          <br />
          Web: http://www.moh.gov.my
          <br />
        </div>
      </div>
      <br />
      {isLoadingPrismaValue ? (
        <div className="preload">
          <img src={gif} alt="Loading..." />
        </div>
      ) : (
        <div>
          {prismaValue &&
            prismaValue?.length > 0 &&
            prismaValue?.map(() => {
              return (
                <>
                  <div
                    style={{
                      padding: "1px",
                      textAlign: "left",
                      backgroundColor: "#365F91",
                      color: "white",
                      fontWeight: "bold",
                    }}
                  >
                    <strong>Prisma FlowChart </strong>
                  </div>
                  <div className="container">
                    <div className="row pt-5">
                      <div className="col-sm-12 col-md-3 col-lg-2 mt-2">
                        <div className="identification">
                          <p className="text">Identification</p>
                        </div>
                      </div>
                      <div className="col-col-sm-12 col-md-9 col-lg-10">
                        <div className="row mb-3">
                          <div className="col-sm-12 col-md-12 col-lg-6 mt-2 ">
                            <div className="Number1972">
                              Number of records identified through electronic
                              databases searching (n=
                              {prismaValue[0].onlineSearch})
                            </div>
                          </div>

                          <div className="col-sm-12 col-md-12 col-lg-6 mt-2">
                            <div className="Number53">
                              Number of additional records identified from other
                              sources (n={prismaValue[0].otherSources})
                            </div>
                          </div>
                        </div>

                        <div className="row ">
                          <div className="col-6">
                            <span className="arrow-icon-prisma">
                              {/* <i className='bi bi-arrow-down-short'></i> */}
                              ↓
                            </span>
                          </div>
                          <div className="col-6">
                            <span className="arrow-icon-prisma">↓</span>
                          </div>
                        </div>

                        <div className="row pt-2 mb-3 ">
                          <div className="col-12">
                            <div className="Num2055">
                              Number of records after duplicates removed (n=
                              {prismaValue[0].abstract_articles_count})
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-sm-12 col-md-3"></div>
                      <div className="col-sm-12 col-md-9 col-lg-10">
                        <span className="arrow-icon-prisma">↓</span>
                      </div>
                    </div>

                    <div className="row ">
                      <div className="col-sm-12 col-md-3 col-lg-2 mt-2">
                        <div className="Screening">
                          <p className="text">Screening</p>
                        </div>
                        <div className="row pt-2">
                          <div className="col-sm-12 col-md-3 col-lg-2 ">
                            <div className="included">
                              <p className="text">included</p>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="col-col-sm-12 col-md-9 col-lg-10">
                        <div className="row mb-3">
                          <div className="col-sm-12 col-md-12 col-lg-1 "></div>
                          <div className="col-sm-12 col-md-12 col-lg-5 mt-2">
                            <div className="num_1925">
                              Number of records screened (n=
                              {prismaValue[0].abstract_articles_count})
                            </div>
                          </div>

                          <div className="col-sm-12 col-md-12 col-lg-1">
                            <span className="arrow-icon-prisma text-icon arrow-icon-prisma-right">
                              {/* <i className='bi bi-arrow-down-short'></i> */}
                              →
                            </span>
                          </div>

                          <div className="col-sm-12 col-md-12 col-lg-5 mt-2 ">
                            <div className="num1200">
                              Number of records excluded (n=
                              {prismaValue[0].abstract_articles_count -
                                prismaValue[0].fulltext_articles_count}
                              )
                            </div>
                          </div>
                        </div>
                        <div className="row">
                          <div className="col-sm-12 col-md-12 col-lg-7">
                            <span className="arrow-icon-prisma">
                              {/* <i className='bi bi-arrow-down-short'></i> */}
                              ↓
                            </span>
                          </div>
                        </div>

                        <div className="row ">
                          <div className="col-sm-12 col-md-12 col-lg-1 col-xxl-1 "></div>
                          <div className="col-sm-12 col-md-12 col-lg-5 col-xxl-5 ">
                            <div className="row mb-3">
                              <div className="col">
                                <div className="num685">
                                  Number of full-text articles assessed for
                                  eligibility (n=
                                  {prismaValue[0].fulltext_articles_count})
                                </div>
                              </div>
                            </div>
                            <div className="col-sm-12 col-md-12 col-lg-12">
                              <span className="arrow-icon-prisma">
                                {/* <i className='bi bi-arrow-down-short'></i> */}
                                ↓
                              </span>
                            </div>
                            <div className="row ">
                              <div className="col">
                                <div className="mt-2 yelllowbox">
                                  Number of full-text articles included in
                                  qualitative synthesis (n=
                                  {prismaValue[0].included_articles_count})
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-sm-12 col-md-12 col-lg-1 col-xxl-1 ">
                            <span className="arrow-icon-prisma text-icon arrow-icon-prisma-right">
                              {/* <i className='bi bi-arrow-down-short'></i> */}
                              →
                            </span>
                          </div>
                          <div className="col-sm-12 col-md-12 col-lg-5 col-xxl-5">
                            <div className="num432">
                              Number of full-text articles excluded (n=
                              {prismaValue[0].fulltext_articles_count -
                                prismaValue[0].included_articles_count}
                              ) <br></br> Reasons:
                              {reasons &&
                                reasons
                                  .filter((exclusion) => exclusion.stage === 3)
                                  ?.map(({ purpose, total }, index) => {
                                    return (
                                      <small>
                                        <br></br>
                                        {purpose.label} (n = {total})
                                      </small>
                                    );
                                  })}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              );
            })}
        </div>
      )}
    </div>
  );
}
export default TechScan;
